export default class BreadCrumbActionTypes {
  public static CHANGE = 'CHANGE';

  public static ADD = 'ADD';

  public static REMOVE = 'REMOVE';
}
